<!-- Overlay backdrop — sits below topbar, click to close -->
<div class="filter-overlay" [class.open]="visible" (click)="onOverlayClick()"></div>

<!-- Sliding panel -->
<div class="filter-panel" [class.open]="visible">

  <!-- Header -->
  <div class="filter-panel-header">
    <span class="filter-sidebar-title">{{ title | translate }}</span>
    <div class="filter-sidebar-actions">
      <button type="button" class="filter-clear-btn" (click)="clearAll()">{{'text.clearAll' | translate}}</button>
      <button type="button" class="filter-close-btn" (click)="close()" aria-label="Close">
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>

  <!-- Hint -->
  <div class="filter-sidebar-hint">{{ hint | translate }}</div>

  <!-- Scrollable body -->
  <div class="filter-panel-body" [formGroup]="filterForm">
    <ng-container *ngFor="let field of fields">
      <div class="filter-field">
        <label [for]="field.name">{{ field.label.startsWith('text.') ? (field.label | translate) : (`text.${field.label}` | translate) }}</label>

        <!-- Calendar -->
        <ng-container *ngIf="field.type === 'calendar'">
          <p-calendar [formControlName]="field.name"
            [dateFormat]="field.dateFormat || 'yy-mm-dd'"
            [placeholder]="(field.placeholder || 'YYYY-MM-DD') | translate"
            [minDate]="field.minDate || null"
            [maxDate]="field.maxDate || null"
            appendTo="body"
            [inputId]="field.name"
            [style]="{'width':'100%'}"
            [inputStyle]="{'width':'100%'}">
          </p-calendar>
        </ng-container>

        <!-- Dropdown -->
        <ng-container *ngIf="field.type === 'dropdown'">
          <p-dropdown [formControlName]="field.name"
            [options]="field.options || []"
            optionLabel="name"
            [optionValue]="field.optionValue || 'value'"
            [placeholder]="(field.placeholder | translate) || ('Select ' + (field.label | translate))"
            appendTo="body"
            [inputId]="field.name"
            [style]="{'width':'100%'}">
          </p-dropdown>
        </ng-container>

        <!-- Multi-select -->
        <ng-container *ngIf="field.type === 'multi-select'">
          <p-multiSelect [formControlName]="field.name"
            [options]="field.options || []"
            [showClear]="true"
            optionLabel="name"
            [optionValue]="field.optionValue || (field.name === 'Report_Category' ? 'code' : 'value')"
            [optionDisabled]="field.optionDisabled || null"
            [maxSelectedLabels]="field.maxSelectedLabels ?? 0"
            [placeholder]="(field.placeholder | translate) || ('Select ' + (field.label | translate))"
            [overlayOptions]="{appendTo: 'body'}"
            [attr.aria-label]="filterForm.get(field.name)?.value ? filterForm.get(field.name)?.value + 'selected' : ('select ' + (field.label | translate))"
            [inputId]="field.name"
            [virtualScroll]="true"
            (onPanelHide)="field.name === 'Report_Category' ? onFieldPanelHide(field.name) : null"
            [virtualScrollItemSize]="55"
            [panelStyle]="{'max-width': '18.15rem'}"
            [style]="{'width':'100%'}">
          </p-multiSelect>
        </ng-container>
          
        <!-- Text input -->
        <ng-container *ngIf="field.type === 'text'">
          <input type="text" pInputText
            [formControlName]="field.name"
            [placeholder]="(field.placeholder | translate) || ''"
            [id]="field.name" />
        </ng-container>
      </div>
    </ng-container>
  </div>

  <!-- Footer -->
  <div class="filter-panel-footer">
    <button type="button" class="filter-submit-btn" (click)="submit()">
      {{ (submitLabel) | translate }}
    </button>
  </div>

</div>

<!-- Validation popup -->
<p-dialog header="{{'text.headerName' | translate}}" [(visible)]="showValidationDialog" [modal]="true"
  [style]="{width: '30vw'}" [closable]="true">
  <div class="row">
    <label>{{ validationMessage }}</label>
  </div>
  <p-footer>
    <button type="button" class="ey-secondary-dark me-2 mt-0" (click)="showValidationDialog = false">
      {{ 'text.okay' | translate }}
    </button>
  </p-footer>
</p-dialog>
